export const range = (length: number): number[] => Array.from({ length }, (_element, index) => index)
